import { ChangeDetectionStrategy, Component } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Observable } from 'rxjs';

import { CoachSettingsGeneralFormController } from 'presentation/page/settings/coach-settings/coach-settings-general/coach-settings-general-form.controller';

import { CoachSettingsGeneralController } from './coach-settings-general.controller';
import { CoachSettingsGeneralStore } from './coach-settings-general.store';

@Component({
	selector: 'spr-coach-settings-general',
	templateUrl: './coach-settings-general.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	providers: [
		CoachSettingsGeneralStore,
		CoachSettingsGeneralController,
		CoachSettingsGeneralFormController,
	],
	host: {
		class: 'h-full flex items-stretch flex-col pb-3',
	},
})
export class CoachSettingsGeneralComponent {
	public form: FormGroup;
	public isSaving$: Observable<boolean>;
	public formValid$: Observable<boolean>;

	constructor(
		private _controller: CoachSettingsGeneralController,
		private _formController: CoachSettingsGeneralFormController
	) {
		this.formValid$ = _controller.formValid$;
		this.isSaving$ = _controller.isSaving$;
		this.form = _formController.form as FormGroup;
	}

	public onUpdateClick() {
		this._controller.updateUser();
	}
}
